<div
  class="deliverable-analytics-content flex h-full min-h-0 flex-1 flex-col items-center pl-6 pr-8"
  [ngClass]="{ 'max-md:px-0': creatorBriefingMode() }"
>
  <div class="deliverable-analytics-content__body flex min-h-0 flex-1 flex-col w-full">
    @switch (platformFeature()) {
      @case (EPlatformFeature.twitchStream) {
        <app-twitch-stream-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.instagramPost) {
        <app-instagram-post-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.instagramReel) {
        <app-instagram-reel-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.youtubeShort) {
        <app-youtube-short-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.youtubeVod) {
        <app-youtube-vod-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.tiktokPost) {
        <app-tiktok-post-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.facebookPost) {
        <app-facebook-post-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.xPost) {
        <app-x-post-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.youtubeStream) {
        <app-youtube-stream-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
      @case (EPlatformFeature.instagramStory) {
        <app-instagram-story-details
          class="deliverable-analytics-platform"
          [deliverableForm]="deliverableForm()"
          [deliverableId]="deliverableId()"
          [deliverableType]="deliverableType()"
          [executionAnalytics]="executionAnalytics()"
          [platformFeature]="platformFeature()"
          [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
        />
      }
    }
  </div>
</div>
